import { all } from "redux-saga/effects";
import { registerWatcher } from "./actions/auth";
import { ordersWatcher } from "./actions/orders";
import { shipNPayWatcher } from "./actions/shipmentNPayment";

export function* rootSagas() {
  yield all([registerWatcher(), ordersWatcher(), shipNPayWatcher()]);
}
